angular.module('impactx.login').controller('LoginController', [
    '$scope',
    'LoginService',
    'cookieService',
    'BrowserSettings',
    '$mdDialog',
    'AppConfiguration',
    'LegalLinking',
    'TranslationService',
    'MinWidthService',
    'ixaUserActions',
    'dataGen',
    '$location',
    LoginController]);

function LoginController($scope, LoginService, cookieService, BrowserSettings, $mdDialog, AppConfiguration,
                         LegalLinking, TranslationService, MinWidthService, ixaUserActions, dataGen, $location) {
    cookieService.removeCookie("loginPage");
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.loginAllowed = BrowserSettings.cookiesEnabled;
    LoginService.prepareLogin(dialogFunction);
    $scope.translations = TranslationService;

    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.backgroundImage = AppConfiguration.get('loginPageBackgroundUrl');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
    MinWidthService.setSpecialMinWidthForDialog($scope, 0);

    function dialogFunction() {
        if ($location.path().indexOf("register") > -1) {
            TranslationService.initializeWithLanguage(dataGen, TranslationService.getCurrentLanguage()).then(function () {
                ixaUserActions.openUserRegistrationDialog(0, null).then(function (answer) {
                    TranslationService.reset(dataGen);
                    $mdDialog.show({
                        multiple: true,
                        templateUrl: './modules/login/templates/login.tmpl.html',
                        controller: 'LoginDialogController',
                        controllerAs: "loginCtrl",
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        fullscreen: false,
                        onComplete: function (scope) {
                            scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                            scope.isLoaded = true;
                        }
                    });
                })
            });
        }
        else
        {
            $mdDialog.show({
                multiple: true,
                templateUrl: './modules/login/templates/login.tmpl.html',
                controller: 'LoginDialogController',
                controllerAs: "loginCtrl",
                clickOutsideToClose: false,
                escapeToClose: false,
                fullscreen: false,
                onComplete: function (scope) {
                    scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                    scope.isLoaded = true;
                }
            });
        }
    }
}